import { AlertTriangle } from 'lucide-react';
import { Button } from './ui/button';

const NumBtn = ({ value, onOpen, testId, className = '', title }) => (
  <button
    type="button"
    onClick={onOpen}
    title={title}
    data-testid={testId}
    className={`font-mono tabular-nums text-sm rounded px-1 -mx-1 hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-colors ${value > 0 ? '' : 'text-muted-foreground'} ${className}`}
  >
    {value}
  </button>
);

export const QtyCells = ({ inv, onOpen, visible = () => true }) => {
  const low = inv.effective_reorder_threshold && inv.qty_on_hand <= inv.effective_reorder_threshold;
  const held = (key, label) => visible(key) && (
    <td className="py-2 px-2 text-right hidden md:table-cell">
      <NumBtn value={inv[key]} onOpen={onOpen} testId={`qty-${key}-${inv.id}`} title={`${label}: view breakdown`}
        className={inv[key] > 0 ? 'text-amber-700 dark:text-amber-300' : ''} />
    </td>
  );
  return (
    <>
      {visible('qty_on_hand') && <td className="py-2 px-2 text-right hidden md:table-cell">
        <NumBtn value={inv.qty_on_hand} onOpen={onOpen} testId={`qty-breakdown-${inv.item_id}`} title="Total on hand: view breakdown"
          className={`font-medium ${inv.is_negative ? 'text-destructive' : low ? 'text-amber-600' : ''}`} />
      </td>}
      <td className="py-2 px-2 text-right">
        <div className="flex flex-col items-end gap-0.5">
          <NumBtn value={inv.available_qty} onOpen={onOpen} testId={`qty-available-${inv.id}`} title="Available: view breakdown"
            className={`font-semibold ${inv.available_qty > 0 ? 'text-emerald-700 dark:text-emerald-400' : ''}`} />
          {inv.over_allocated_by > 0 && (
            <button type="button" onClick={onOpen} data-testid={`over-by-${inv.id}`} title="Allocated + quarantined exceed on hand: needs reconciliation"
              className="inline-flex items-center gap-0.5 rounded-full border border-red-300 bg-red-50 px-1.5 text-[10px] font-semibold text-red-700 dark:border-red-800 dark:bg-red-950/50 dark:text-red-300 whitespace-nowrap">
              <AlertTriangle className="w-2.5 h-2.5" /> Over<span className="hidden sm:inline">&nbsp;by</span>&nbsp;{inv.over_allocated_by}
            </button>
          )}
          {inv.reserved_short_by > 0 && (
            <button type="button" onClick={onOpen} data-testid={`reserved-short-${inv.id}`} title="Part requests reserve more than is left"
              className="inline-flex items-center rounded-full border border-amber-300 bg-amber-50 px-1.5 text-[10px] font-medium text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300 whitespace-nowrap">
              Short {inv.reserved_short_by}<span className="hidden sm:inline">&nbsp;for requests</span>
            </button>
          )}
          <span className="md:hidden text-[10px] text-muted-foreground whitespace-nowrap">of {inv.qty_on_hand}<span className="hidden sm:inline"> on hand</span></span>
        </div>
      </td>
      {held('allocated_qty', 'Allocated to jobs')}
      {held('reserved_qty', 'Reserved for part requests')}
      {held('quarantined_qty', 'Quarantined')}
    </>
  );
};

export const OverCommittedBanner = ({ count, active, onToggle }) => {
  if (!count && !active) return null;
  return (
    <div className="mt-2 inline-flex flex-wrap items-center gap-2 rounded-lg border border-red-300 bg-red-50 px-2.5 py-1.5 text-xs text-red-800 dark:border-red-800 dark:bg-red-950/40 dark:text-red-300" data-testid="over-committed-banner">
      <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
      <span>{count} {count === 1 ? 'item has' : 'items have'} more allocated or quarantined than on hand</span>
      <Button size="sm" variant={active ? 'default' : 'outline'} className="h-6 px-2 text-xs" onClick={onToggle} data-testid="over-committed-toggle">
        {active ? 'Show all' : 'Show only these'}
      </Button>
    </div>
  );
};
